import fetchAPI from "./fetchAPI"

export async function searchContent(site, search, context, filters) {
  const { searchContent } = await fetchAPI(
    `query($site: String!, $search: String, $context: searchContext!, $filters: JSON!) {
        searchContent(site: $site, search: $search, context: $context, filters: $filters) {
          list
          totalCount
          maxPage
        }
      }`,
    {
      variables: { site, search, context, filters: filters }
    }
  )

  return searchContent
}
